// extracted by mini-css-extract-plugin
export default {"description":"NM6uXr","descriptionLargeDesktop":"zkXr4p"};